import { AppLogoWhite } from "../../assets/svgs";
import styles from "./OtpVerification.module.css";
import { Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { BsShieldCheck } from "react-icons/bs";
import { useEffect, useRef, useState } from "react";
import AuthCode from "react-auth-code-input";
import useNotification from "../../hooks/useNotification";
import AuthServices from "../../services/AuthServices";
import Session from "store2";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { DASHBOARD } from "../../urlConfig";

const defaultState = {
  emailAddress: "",
  password: "",
  usertype: false,
  invalidPassword: false,
};

const OtpVerification = () => {
  const AuthInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState("");
  const [data, setData] = useState(defaultState);
  const { showNotification } = useNotification();
  const location = useLocation();
  const navigate = useNavigate();
  const { changeUserData } = useContext(AuthContext);

  const type = location?.state;

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const emailParam = urlSearchParams.get("emailAdress");

    if (emailParam) {
      const emailValue = emailParam.replace(/\+/g, "%2B");
      handleChange("emailAddress", emailValue);
    }
  }, []);

  const handleChange = (key, value) => {
    setData((pre) => ({ ...pre, [key]: value }));
  };

  const resendOTP = async () => {
    setResult("");
    AuthInputRef.current?.clear();
    try {
      const OtpPayload = {
        email: type.email,
      };
      const sendOtpCode = await AuthServices.SendOTP(OtpPayload);
      if (sendOtpCode.statusCode === 1) {
        // Show success snackbar
        showNotification("OTP Resent Successfully");
      } else {
        // Show error snackbar
        showNotification("Failed to Resend OTP. Please try again.", "error");
      }
    } catch (error) {
      showNotification("Error resending OTP. Please try again.", "error");
    }
  };

  const handleOTPSubmit = async () => {
    try {
      setLoading(true);
      const verifyOtpPayload = {
        otp: result,
        email: type.email,
      };
      const verifyOtpResponse = await AuthServices.VerifyOTP(verifyOtpPayload);
      if (verifyOtpResponse.statusCode === 1) {
        const userData = verifyOtpResponse.data;

        Session.session("token", userData.token);
        sessionStorage.setItem("userData", JSON.stringify(userData));
        changeUserData({
          ...userData,
          isAuthenticated: true,
        });
        navigate(DASHBOARD);
      } else {
        showNotification(`${verifyOtpResponse.data.status}`, "error");
      }
    } catch (error) {
      if (error.statusCode === 0) {
        console.log("Error while verifying OTP", error);
        showNotification(error.statusDesc, "error");
      } else {
        console.log("Error while verifying OTP", error);
        showNotification(`Error while verifying OTP`, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.login_wrap}>
      <div className={styles.logo_wrap}>
        <AppLogoWhite />
      </div>
      <div className={styles.header_line}>Welcome back to IndexScore!</div>
      <div className={styles.icon}>
        <div className={styles.icon_wrap}>
          <BsShieldCheck />
        </div>
      </div>

      <h5 className={styles.title}>Two-Factor Authentication</h5>
      <AuthCode
        allowedCharacters="numeric"
        ref={AuthInputRef}
        inputClassName={styles.input_wrap}
        onChange={(value) => {
          setResult(value);
        }}
      />
      <div className={styles.description_wrap}>
        <p className={styles.description}>
          A message with a verification code has been sent to your phone number.
          Enter the code to continue.
        </p>
      </div>
      <div>
        <button
          className={styles.submit_btn}
          onClick={() => handleOTPSubmit()}
          disabled={loading}
        >
          {loading ? <Spin /> : "Verify OTP"}
        </button>
      </div>
      <button className={styles.resend_btn} onClick={resendOTP}>
        Resend OTP
      </button>
    </div>
  );
};

export default OtpVerification;
